import type { CanDeactivateFn } from '@angular/router';

/**
 * A screen that can hold work typed and not saved yet.
 *
 * `canLeave` answers whether the reader may go: at once when nothing is
 * waiting, else once they have chosen on the screen's own question.
 */
export interface HoldsUnsavedWork {
  canLeave(): boolean | Promise<boolean>;
}

/**
 * Asks the screen before a link, the menu or the back button takes the reader
 * away, so typed work is not dropped without a word (the invoice review,
 * 2026-10-07). Closing the tab or reloading is the browser's own question.
 */
export const unsavedWorkGuard: CanDeactivateFn<HoldsUnsavedWork> = (screen) => screen?.canLeave?.() ?? true;
